<div class="section">
           <p class="text-muted-color text-center mb-3">
            <strong>Sign-in</strong>
        </p>
    <form [formGroup]="form" (click)="error = ''">

        <!-- USERNAME -->
        <div class="input-group">
            <span class="input-group-addon">
                <i class="glyphicon glyphicon-user"></i>
            </span>

            <input name="username" id="username" type="text" class="form-control removeBackgroud" placeholder="Username" formControlName="username" />
        </div>

        <!-- PASSWORD -->
        <div class="input-group">
            <span class="input-group-addon">
                <span class="glyphicon glyphicon-lock"></span>
            </span>

            <input name="password" id="password" [type]="showPassword ? 'text' : 'password'" class="form-control removeBackgroud"
                placeholder="Password" formControlName="password" (keydown)="keyDownFunction($event, form.value)" />

            <span class="input-group-addon removeBackgroud">
                <span (click)="togglePassword()" class="glyphicon eyeIcon"
                    [ngClass]="showPassword ? 'glyphicon-eye-close' : 'glyphicon-eye-open'"></span>
            </span>
        </div>

        <button id ="loginButton" type="button" class="btn btn-md btn-primary btn-block defaultBtnColor" (click)="loginUser(form.value)"
            [disabled]="!form.valid || authenticationService.loading">
            Log In

            @if(authenticationService.loading){
            <img alt="loader" style="text-align:center"
                src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
            }
        </button>

        <div class="text-right mt-2">
            <a id ="forgotPasswordLink" href="javascript:void(0)" (click)="goToForgotPassword()" class="forgot-link">
                Forgot Password?
            </a>
        </div>

    </form>

    @if(error){
    <div class="alert alert-danger">{{error}}</div>
    }
</div>